import React, { useEffect, useState } from 'react'
import Addmodal from '../../common/Modals/Addmodal'
import { getBlogById, getBlogs } from '../../../service/apiService'
import Deletemodal from '../../common/Modals/Deletemodal'

const Cms = () => {
  const [blogdata, setBlogdata] = useState([])
  const [activeTab, setActiveTab] = useState('blog')
  const [editstring, setEditstring] = useState() 
   const [uniqueid, setUniqueid] = useState()
  const [blogmodal, setBlogmodal] = useState(false);
  const showAddBlogModal = () => setBlogmodal(true)
  const closeAddBlogModal = () => setBlogmodal(false)
const [removemodal, setRemovemodal] = useState(false)
const [singleblog, setSingleblog] = useState();


const afterBlogAdd = async () => {
  if( editstring === 'blog' || editstring === 'editblog' || editstring === 'deleteblog'  ){
    let result = await getBlogs()
    setBlogdata(result.data.data)
  }  
} 

const addBlog = () => {
  setEditstring('blog')
  showAddBlogModal()
} 

const EditBlog = async (id) => {
  setUniqueid(id)
  setEditstring('editblog')
  let res = await getBlogById(id)
  setSingleblog(res?.data)
  showAddBlogModal()
}

const deleteBlog = (id) => {
  setUniqueid(id)
  setEditstring('deleteblog')
  setRemovemodal(!removemodal)
}

const init = async () => {
let result = await getBlogs()
setBlogdata(result.data.data)
}

useEffect(() => {
(async () => {
 await init()
})()
},[])
  return (
  <div>
      <div>
                                <div class="right-content">
                             <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                               <h1>CMS</h1> 
                            {removemodal ? <Deletemodal initRefresh={afterBlogAdd} isModalOpen={removemodal} id={uniqueid} closeModal={() => setRemovemodal(!removemodal)} from={editstring} /> : <></>}
  
                             </div>
                             <div class="container-fluid p-0">
                               <div class="settings-tabs">
                                <div>
                                  <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                      <a className={`nav-link ${activeTab === 'blog' ? 'active' : ''}`} data-bs-toggle="tab" href="#home" onClick={() => setActiveTab('blog')}>
                                       <img src="/images/myprofile.svg" />  
                                       <div>
                                        <h6>Blog</h6> 
                                       </div>     
                                      </a>
                                    </li>
                                  </ul> 
                                 </div>
                                  
                                   <div class="full">
                                  <div class="tab-content h-100">
                                    <div  className={`tab-pane container ${activeTab === 'blog' ? 'active' : 'fade'}`} id="home">
                                    <div className='text-white'>{ blogmodal ? <Addmodal show={blogmodal}  handleClose={closeAddBlogModal} id={uniqueid} from={editstring} initRefresh={afterBlogAdd} blogdatas={singleblog} /> : <></> } </div> 
                                      <div class="card mb-4 bg-curve">
                                        <div class="d-flex justify-content-between card-head align-items-center">
                                          <h2 className="mt-3 text-white">Details of Blog</h2>
                                        <button className="tb-add-btn" onClick={addBlog}>AddBlog+</button>
                                        </div>
                                        <div class="table-responsive cmn-table dragscroll">
                                      <table class="w-100">
                                       <thead>
                                        <tr className='text-white'>  
                                        <th>Sl No.</th>   
                                        <th> Name</th>
                                        <th>Description</th>
                                        <th>Author Name</th>
                                        <th>Created Date</th>
                                        <th>Edit</th>  
                                        <th>Delete</th>       
                                       </tr>
                                       </thead>
                                       <tbody className='w-100 text-white'>
                                        {blogdata.map((item,index) => {
                                          return(
                                            <tr key={index}>
                                            <td>{index+1}</td> 
                                            <td>{item.name}</td>
                                            <td>{item.description?.slice(0,60)}</td>
                                            <td>{item.author.name}</td>
                                            <td>{(new Date(item.date)).toLocaleString()}</td>
                                            <td><button class="act-btns" onClick={() => EditBlog(item._id)} ><i class="far fa-redo-alt" ></i> Edit</button>  </td>
                                        
                                            <td>
                                            <button class="act-btns" onClick={() => {deleteBlog(item._id)}}><i class="far fa-edit"></i> Delete</button>

                                            </td>
                                        </tr>)
                                        })} 
                                       </tbody>
                                      </table>
                                      </div>

                                      </div> 
                                    </div>
                                  </div>
                                   </div>
                               </div>
                             </div>  
                          </div>
      </div>
    </div>
  )
}

export default Cms
